import { getBorderRadius } from "@/lib/util";
import { SiteInfo } from "@/types";
import clsx from "clsx";
import { useState } from "react";
import BlurImage from "../BlurImage";
import Button from "../Button";
import Modal from "../Modal";

interface FooterElementProps {
    site?: SiteInfo
}
const FooterElement = ({ site }: FooterElementProps) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <Modal showModal={showModal} setShowModal={setShowModal}>
                <div className="inline-block w-full max-w-md px-10 py-8 align-middle transition-all bg-white rounded-lg shadow-xl">
                    <div className="flex flex-col items-center justify-center space-y-2 text-center">

                        <div className="inline-block object-cover w-16 h-16 overflow-hidden align-middle rounded-full">
                            <BlurImage
                                alt={site?.name!}
                                height={80}
                                src={site?.logo!}
                                blurDataURL={site?.logoBlurHash}
                                width={80}
                                objectFit="cover"
                            />
                        </div>
                        <span className="text-gray-600 text-md">
                            be like <span className="font-medium text-gray-900">{site?.name.split(' ')[0]}</span> today!
                        </span>
                        <span className="text-sm text-gray-400 ">
                            Share your content, links, articles, photos and videos to showcase your work and personality
                        </span>
                        <Button
                            className="hover:bg-gray-600"
                            onClick={() => {
                                window.open('https://curious.page/', '_blank');
                                setShowModal(false);
                            }}
                            title="Get your unique link-in-bio" />
                        <span className="text-sm text-gray-600 cursor-pointer" onClick={() => setShowModal(false)}>not now</span>
                    </div>
                </div>
            </Modal>
            <div onClick={() => {
                if (site?.subdomain && site?.subdomain === 'meta') {
                    window.open(`https://use.curious.page/`);
                    return;
                }
                setShowModal(true)
            }} className="flex flex-col items-center justify-center w-auto cursor-pointer select-none ">
                <div
                    style={{ borderRadius: getBorderRadius(site?.appearance!) }}
                    className="flex items-center justify-center px-3 py-2 duration-1000 ease-in-out transform group">
                    <span className="flex space-x-1.5">
                        <img className="w-5 h-5" src="/images/apple-touch-icon.png" alt="C" />
                        <span className="text-sm duration-1000 ease-in-out transform drop-shadow group-hover:tracking-widest">Create your own page!</span>
                    </span>
                </div>
            </div>
        </>
    )
}


export default FooterElement;